import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
              吃瓜现场
            </h2>
            <p className="text-sm text-foreground-500">
              独家直击 · 录制揭秘 · 活动前瞻，多角度还原事件真相
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {mediaItems.map((item) => (
              <div
                key={item.id}
                className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
              >
                <div className="relative w-full aspect-video overflow-hidden">
                  <img
                    src={item.imageUrl}
                    alt={item.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute bottom-2 right-2 px-2 py-1 rounded-md bg-black/60 text-background-50 text-xs font-medium">
                    <i className="ri-play-circle-line mr-1" />
                    {item.duration}
                  </div>
                  <div className="absolute top-2 left-2">
                    <span className="px-2 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-medium">
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="text-sm md:text-base font-medium text-foreground-900 line-clamp-2 leading-relaxed mb-2">
                    {item.title}
                  </h3>
                  <div className="flex items-center gap-3 text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line" />
                      {item.views}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}